export class DistanceUtils {
  static fromMetre(value?: number, precision?: number) {
    if (value === undefined) {
      return undefined;
    }

    const result = (value || 0) / 1000;

    return precision ? parseFloat(result.toFixed(precision)) : result;
  }

  static toMetre(value?: number): undefined | number {
    if (value === undefined) {
      return undefined;
    }

    return Math.round((value || 0) * 1000);
  }
}
